import { BgImage, NewsFilter, NewsItems } from "@prmf/site-components";
import { Post } from "@prmf/site-data";
import { routes, t } from "@prmf/site-router";
import { clsx } from "clsx";
import {
  NavLink,
  useLoaderData,
  useNavigate,
  useParams,
  useSearchParams,
} from "@remix-run/react";

const categories = [
  {
    link: routes.newsLatestTrends,
    image: "/media/assets/news-cat-latest-trends.jpg",
  },
  {
    link: routes.newsCaseStudies,
    image: "/media/assets/news-cat-case-studies.jpg",
  },
  { link: routes.newsCompany, image: "/media/assets/news-cat-company.jpg" },
  {
    link: routes.newsSustainability,
    image: "/media/assets/news-cat-sustainability.jpg",
  },
];

export default function newsList() {
  const { category } = useParams();
  const [search] = useSearchParams();
  const { posts } = useLoaderData<{ posts: Post[] }>();
  const navigate = useNavigate();
  return (
    <div>
      <BgImage
        overlay={20}
        src="/media/assets/news-hero.jpg"
        className={clsx(
          "grid aspect-[4/3] max-h-[40vh] place-items-center text-center",
          "bg-gray-400 text-2xl font-bold text-white",
        )}
      >
        <h2 className="max-md:container">News, case studies and journal</h2>
      </BgImage>
      <nav className="no-scrollbar container my-4 flex snap-x gap-3 overflow-auto scroll-smooth">
        {categories.map((l) => (
          <NavLink
            to={l.link}
            key={l.link}
            preventScrollReset
            className={clsx(
              "grid flex-1 place-items-center",
              "font-medium uppercase tracking-wider text-white",
              "text-xs lg:text-sm",
              "snap-center",
            )}
          >
            {({ isActive }) => (
              <BgImage
                overlay={isActive ? 0 : 50}
                src={l.image}
                className="h-full rounded p-10 text-center lg:p-14"
              >
                {t(l.link, "title")}
              </BgImage>
            )}
          </NavLink>
        ))}
      </nav>
      <section className="bg-zinc-100 pb-20">
        <div className="container text-neutral-700">
          <NewsFilter
            defaultValue={{ category, date: search.get("date")?.toString() }}
            onChange={({ category, date }) => {
              let path = ["news", category].join("/");
              if (date) path += `?date=${date}`;
              navigate("/" + path, { preventScrollReset: true, replace: true });
            }}
          />
          <NewsItems posts={posts} />
        </div>
      </section>
    </div>
  );
}
